"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends5 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _base = _interopRequireDefault(require("./base"));
var _consts = require("../utils/consts");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The batch service
 */
var Batch = /*#__PURE__*/function (_Base) {
  /**
   * https://platform.stoplight.autodesk.com/docs/docs-cp/k4pfmsaly0ndj-acc-batch-operation-ap-is
   *
   * Create the batch service instance.
   * All ACC batch operations can leverage this service.
   *
   * @param sdk - the SDK instance
   */
  function Batch(sdk) {
    (0, _classCallCheck2["default"])(this, Batch);
    return _callSuper(this, Batch, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(Batch, _Base);
  return (0, _createClass2["default"])(Batch, [{
    key: "create",
    value: (
    /**
     * [Shared] Create a batch task to group several operations.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/1477f01788482-shared-create-a-batch-task
     *
     * @param projectId - , the project id.
     * @param payload -, with shape of `operation` and `content`.
     * @param config -  Configurable object for overwrite request parameters.
     *
     * @returns with shape of id: 'uuid', status: 'string'.
     */
    function () {
      var _create = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId, payload, config) {
        var _this = this;
        var url, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              config = (0, _extends5["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this.createCancelToken;
                },
                setter: function setter(token) {
                  return _this.createCancelToken = token;
                },
                clearer: function clearer() {
                  return _this.createCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/batches");
              _context.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function create(_x, _x2, _x3) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
    /**
     * [Shared] Complete a batch task
     * https://platform.stoplight.autodesk.com/docs/docs-cp/ed25f8389ea8d-shared-complete-a-batch-task
     *
     * @param projectId - the project id.
     * @param batchId - the batch id from create method.
     * @param config -  Configurable object for overwrite request parameters.
     *
     * @returns with shape of id: 'uuid', status: 'string'.
     */
    )
  }, {
    key: "complete",
    value: (function () {
      var _complete = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, batchId, config) {
        var _this2 = this;
        var url, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              config = (0, _extends5["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.completeCancelToken;
                },
                setter: function setter(token) {
                  return _this2.completeCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.completeCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/batches/").concat(batchId, ":complete");
              _context2.next = 4;
              return this.HttpService.dmV3.post(url, undefined, config);
            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function complete(_x4, _x5, _x6) {
        return _complete.apply(this, arguments);
      }
      return complete;
    }()
    /**
     * [Shared] Extend Batch request in-case timeout, max time is 1 hour.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/51f2f8ed15502-shared-extend-batch-timeout
     *
     * @param projectId - the project id.
     * @param batchId - the batch id from create method.
     * @param config -  Configurable object for overwrite request parameters.
     *
     * @returns with shape of id: 'uuid', status: 'string'.
     */
    )
  }, {
    key: "extend",
    value: (function () {
      var _extend = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, batchId, config) {
        var _this3 = this;
        var url, response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              config = (0, _extends5["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this3.extendCancelToken;
                },
                setter: function setter(token) {
                  return _this3.extendCancelToken = token;
                },
                clearer: function clearer() {
                  return _this3.extendCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/batches/").concat(batchId, ":extend");
              _context3.next = 4;
              return this.HttpService.dmV3.post(url, undefined, config);
            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function extend(_x7, _x8, _x9) {
        return _extend.apply(this, arguments);
      }
      return extend;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Batch';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = Batch;